import React from "react";
import ReactDOM from "react-dom";
import BaseComponent from "./BaseComponent";
import CanvasTabManager from "../utilities/CanvasTabManager";
import Utility from "../utilities/Utility";

/**
 * @class IntentListItem
 */
export default class IntentListItem extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            showJsx: false,
            showModuleEditDropDown: false,
            isModuleEdit: false
        };
    }

    getDomSelf() {
        return $(ReactDOM.findDOMNode(this));
    }

    removeSubmenu() {
        this.setState({ showJsx: false });
    }
    openCanvas(module) {
        w2popup.close();
        $('a[href="#"]')[0].click();

        CanvasTabManager.addTab(module);
    }
    initEditMapping(event) {
        event.preventDefault();
        event.stopPropagation();
        const x = event.target.offsetParent.offsetTop - 2;
        const y = event.target.offsetParent.offsetLeft;
        const w = event.target.offsetParent.offsetWidth - 1;
        const dataset = $(event.target).closest('li')[0].dataset;
        this.props.context.setSelectedIntentListItem(JSON.parse(JSON.stringify(dataset)));
        this.props.context.initEditMappingDropdown(x, y, w);
        this.setState({ 'isModuleEdit': true });
    }
    getConditionDescription(id) {
        const globalIntent = window.apm.serialized.globalIntents.find(gi => gi.id === id);
        if (globalIntent) {
            $(".link_wrapper")[0].innerText = globalIntent.conditionProperties.props.config?.description ?? "";
            if ($(".link_wrapper")[0].innerText !== "") {
                return $(".link_wrapper")
                    .css({
                        top: event.clientY - 10,
                        left: event.clientX + 30
                    })
                    .show();
            }
        }
    }
    completeEditMapping() {
        this.setState({ 'isModuleEdit': false });
    }
    getModule(id) {
        var moduleIndex = window.apm.serialized.globalIntents.findIndex(globalIntent => globalIntent.id === id);
        return window.apm.serialized.globalIntents[moduleIndex];
    }
    /**
     * @param {string} id of the global intent to find the index of.
     */
    getGlobalIntentIndex(id) {
        return window.apm.serialized.globalIntents.findIndex(globalIntent => globalIntent.id === id);
    }

    getInputs(module, moduleProps) {
        let inputs = [];
        if (module && moduleProps &&moduleProps.props.config&& moduleProps.props.config.inputs && moduleProps.props.config.inputs.length > 0) {
            for (var i = 0; i < moduleProps.props.config.inputs.length; i++) {
                const input = moduleProps.props.config.inputs[i];
                if (input.argumentName!=="out"&&input.type === "value"&& input.value && input.value !== "") {
                    var inputName = input.argumentName + " = " + input.value;
                    inputs.push(
                        <div key={Utility.uuid4()} style={{ color: "var(--color-text-lighter)" }}>
                            <span style={{ paddingLeft: "6px" }}> {inputName}</span>
                        </div>
                    )
                }
                else if (input.argumentName!=="out"&&input.type === "variable" && input.varName&&input.varName !== "") {
                    var inputName = input.argumentName + " = " + input.varName;
                    inputs.push(
                        <div key={Utility.uuid4()} style={{ color: "var(--color-text-lighter)" }}>
                            <span style={{ paddingLeft: "6px" }}> {inputName}</span>
                        </div>
                    )
                }
            }
        }
        return inputs;
    }
    render() {
        var intName = "<UNKNOWN: " + this.props.data.intent.substring(this.props.data.intent.length - 6) + ">";
        var greyInt = true;
        var modName = <b>???</b>;
        var greyMod = true;
        var inputs = this.getInputs(this.props.data.module, this.props.data.moduleProperties);
        const node = window.apm.getNode(this.props.data.intent);
        const mod = window.apm.getNode(this.props.data.module);
        
        if (node) {
            var intentIndex = window.apm.serialized.components.intents.findIndex(i => i.id === node.id);
            window.apm.serialized.components.intents[intentIndex].isGlobalIntent = true;
             intName = node.name;

            var conditionName=this.props.data.conditionProperties.props.config.name!==""?this.props.data.conditionProperties.props.config.name:this.props.data.conditionProperties.props.config.serializedCondition
            if (conditionName!== "") {
                intName = `${node.name} + ${conditionName}`
            }
            intName = intName.length > 35 ? intName.substring(0, 35) + "…": intName;
            greyInt = false;

            if (mod) {
                if (mod.name.length > 35) modName = mod.name.substring(0, 30) + "…";
                else modName = mod.name;
            }
            if (intName !== modName) {
                greyMod = false;
            }
        }

        var intentDup = window.apm.serialized.globalIntents.filter(intent => intent.intent === this.props.data.intent&& intent.conditionProperties.props.config.serializedCondition===this.props.data.conditionProperties.props.config.serializedCondition);
        var color = intentDup.length > 1 ? "var(--color-error)" : "inherit";
        return (
            <li style={{color}}data-id={this.props.data.id}
                data-conditionproperties={JSON.stringify(this.props.data.conditionProperties)}
                data-int={this.props.data.intent}
                data-mod={this.props.data.module}
                data-modproperties={JSON.stringify(this.props.data.moduleProperties)}
                created-time={this.props.data.createdTime}
                lastsavedchange={this.props.data.lastSavedChange}
                className={"intent-row" + (greyInt && greyMod ? " greyout" : "") + (this.props.highlight ? " highlight" : "")}
                onClick={event => {
                    event.stopPropagation();
                    $(".intent-name").removeClass("selected");
                    $(".intent-row").removeClass("selected");
                    $(".mod-name").removeClass("selected");
                    $(event.currentTarget).addClass("intent-row selected")}}>
                <div className={"intent-cell"}>
                    <div className="icon-container icon-left">
                        <i className={"fe icon-compass"} />
                    </div>
                    <div className={"intent-name"} data-id={this.props.data.id} data-intent={this.props.data.intent} data-globalintentindex = {this.getGlobalIntentIndex(this.props.data.id)}onMouseEnter={event => this.getConditionDescription(event.currentTarget.dataset.id)} onMouseLeave={() => $(".link_wrapper").hide()}
                        onClick={event => {
                        event.stopPropagation();
                        $(".intent-name").removeClass("selected");
                        $(".mod-name").removeClass("selected");
                        $(".intent-row").removeClass("selected");
                        $(".intent-row")[event.currentTarget.dataset.globalintentindex].className= "intent-row selected";
                        document.dispatchEvent(new CustomEvent("intents-transition-property-panel", {detail: {event: { id: event.currentTarget.dataset.id }}}));
                    }}>
                        {intName}
                    </div>
                    <div className="icon-container icon-right" data-intent={this.props.data.intent} data-id={this.props.data.id} data-globalintentindex = {this.getGlobalIntentIndex(this.props.data.id)}
                        onClick={event => {
                            event.stopPropagation();
                            $(".intent-name").removeClass("selected");
                            $(".mod-name").removeClass("selected");
                            $(".intent-row").removeClass("selected");
                            $(".intent-row")[event.currentTarget.dataset.globalintentindex].className= "intent-row selected";
                            document.dispatchEvent(new CustomEvent("intents-component-property-panel", {detail: {event: {id: event.currentTarget.dataset.intent }}}));
                        }}>
                        
                        <i className={"icon-radio"} />
                        </div>
                    <div className="icon-container icon-right">
                        <i className={"fe icon-chevrons-right"} />
                    </div>
                </div>
                <div className={"intent-cell"} style={{ padding: "5px 0px" }}>
                    {inputs.length > 0 && <div  data-id={this.props.data.id} data-intent={this.props.data.intent} data-globalintentindex = {this.getGlobalIntentIndex(this.props.data.id)}data-module={this.props.data.module} className={"mod-name"}
                        onClick={event => {
                            event.stopPropagation();
                            const intentIndex = 
                                $(".intent-row").removeClass("selected");
                                $(".intent-name").removeClass("selected");
                                $(".mod-name").removeClass("selected");
                                $(".intent-row")[event.currentTarget.dataset.globalintentindex].className= "intent-row selected";
                                if (event.currentTarget.dataset.module) {
                                    document.dispatchEvent(new CustomEvent("intents-globalModule-property-panel", {detail: {event: { id: this.getModule(event.currentTarget.dataset.id).module, node: this.getModule(event.currentTarget.dataset.id).moduleProperties , intent:event.currentTarget.dataset.intent}}}));
                                }
                            
                        }}>
                        <div className="icon-container icon-left">
                            <i className="icon-box" /><span style={{ paddingLeft: "6px" }}>{modName}</span>
                        </div>
                        {inputs}
                    </div>}
                    {inputs.length === 0 && <React.Fragment><div className="icon-container icon-left">
                        <i className="icon-box" />
                    </div>
                        <div className={"mod-name"} data-id={this.props.data.id} data-intent={this.props.data.intent} data-module={this.props.data.module} data-globalintentindex = {this.getGlobalIntentIndex(this.props.data.id)}
                            onClick={event => {
                                event.stopPropagation();
                                $(".intent-row").removeClass("selected");
                                $(".intent-name").removeClass("selected");
                                $(".mod-name").removeClass("selected");
                                $(".intent-row")[event.currentTarget.dataset.globalintentindex].className= "intent-row selected";
                                if (event.currentTarget.dataset.module) {
                                    document.dispatchEvent(new CustomEvent("intents-globalModule-property-panel", {detail: {event: { id: this.getModule(event.currentTarget.dataset.id).module, node: this.getModule(event.currentTarget.dataset.id).moduleProperties,intent:event.currentTarget.dataset.intent }}}));
                                } 
                            }}>
                            {modName}
                        </div>
                    </React.Fragment>}
                    <div className="icon-container icon-right" data-intent={this.props.data.intent}data-module={this.props.data.module}
                        onClick={event => { if(mod){this.openCanvas(mod)} else{ event.preventDefault();
                            event.stopPropagation();
                            const intent = event.currentTarget.dataset.intent;
                            this.initEditMapping(event)}}}>
                        <i className={"fe icon-external-link"} />
                    </div>
                    <div className="icon-container icon-right" data-intent={this.props.data.intent} data-id={this.props.data.id}
                        onClick={event => {
                            event.preventDefault();
                            event.stopPropagation();
                            this.initEditMapping(event)
                        }}>
                        <i className={"icon-edit"} />
                    </div>
                    <div className="icon-container icon-right" data-id={this.props.data.id}
                        onClick={event => {
                            event.preventDefault();
                            event.stopPropagation();
                            const id = event.currentTarget.dataset.id;
                            this.props.context.removeIntent(id, event)
                        }}>
                        <i className={"icon-delete"} />
                    </div>
                </div>
            </li>
        );
    }
}
